import Pill from '../Components/Pill'
import {useParams} from 'react-router-dom'



function Galleryitem(props) {
    const COL_SPANS = {
        1: 'md:col-span-1',
        2: 'md:col-span-2',
      };
    

    let {projectName} = useParams();
    let project = require("../projects.json");
    let projectinfo = project.filter(project => project.project_name === projectName)[0];
    // const colSpanClass = `col-span-${props.colSpan}`;
    

    return (
        
        <div className={`col-span-1 ${COL_SPANS[props.colSpan]}`}> 
        
            <div className="flex align-middle w-full items-start aspect-[4/2.8] overflow-hidden rounded-image">
                <img 
                    src={`/img/${projectinfo.folder}/${props.image}`}
                    alt={`Afbeelding voor ${projectinfo.project_name}`} 
                    className="w-full h-full object-cover align-middle rounded-image"
                />
                
                <div className='absolute items-top pt-4 px-4'>
                    <Pill>{props.pill}</Pill>
                </div>
            </div>
            
        </div>
        
    );
  }
  
  export default Galleryitem;